import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f84ab4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert-container" }
const _hoisted_2 = {
  key: 0,
  class: "icon clock"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-clock" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "icon circle-exclamation"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-circle-exclamation" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "icon"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-circle-check" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 3,
  class: "icon"
}
const _hoisted_12 = {
  key: 4,
  class: "icon"
}
const _hoisted_13 = {
  key: 5,
  class: "icon"
}
const _hoisted_14 = {
  key: 6,
  class: "dual-icon"
}
const _hoisted_15 = { class: "alert-text" }
const _hoisted_16 = { class: "alert-text-title" }
const _hoisted_17 = { class: "alert-text-message" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-xmark" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgWrenchWithCircle = _resolveComponent("SvgWrenchWithCircle")!
  const _component_SvgLocation = _resolveComponent("SvgLocation")!
  const _component_SvgCamera = _resolveComponent("SvgCamera")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["banner-container", _ctx.bannerType])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.useClockIconType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.useExclamationIconType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true),
      (_ctx.useCheckIconType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
        : _createCommentVNode("", true),
      (_ctx.useWrenchIconType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_SvgWrenchWithCircle)
          ]))
        : _createCommentVNode("", true),
      (_ctx.useLocationIconType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_SvgLocation)
          ]))
        : _createCommentVNode("", true),
      (_ctx.useCameraIconType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_SvgCamera)
          ]))
        : _createCommentVNode("", true),
      (_ctx.useCameraAndLocationType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_SvgCamera),
            _createVNode(_component_SvgLocation)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.alertMessageTitle), 1),
        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.alertMessage), 1),
        (_ctx.showPermissionBeggingLink)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "more-link",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPermissionsStepsGuide && _ctx.showPermissionsStepsGuide(...args)))
            }, " Click for More Info "))
          : _createCommentVNode("", true)
      ])
    ]),
    (!_ctx.alertHasDuration)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "x-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeAlert && _ctx.closeAlert(...args)))
        }, _hoisted_19))
      : _createCommentVNode("", true)
  ], 2))
}